import Interview from 'types/Interview';

/** Given an interview, returns an object containing the mentee's full name and the mentor's full name.*/
const getInterviewNames = (
  interview: Interview | undefined,
): { mentor: string; mentee: string } => {
  let mentee = '';
  let mentor = '';

  if (
    interview?.mentorship?.mentee?.firstName &&
    interview.mentorship.mentee.lastName
  ) {
    mentee = `${interview?.mentorship?.mentee?.firstName} ${interview.mentorship.mentee.lastName}`;
  }

  if (
    interview?.mentorship?.mentor?.firstName &&
    interview.mentorship.mentor.lastName
  ) {
    mentor = `${interview?.mentorship?.mentor?.firstName} ${interview.mentorship.mentor.lastName}`;
  }
  return { mentee, mentor };
};

export default getInterviewNames;
